/**
 * Expandable degree information sections on UG A-Z page
 */
$(function() {
    // find all the expandy links
    $('.collapser-button').each(function () {
        // grab the id
        let id = $(this).attr('id').split('_')[2];
        let isVisible = false;

        // find the associated panel
        let panel = $('#programmes_' + id);

        $(this).attr('aria-expanded', isVisible);
        $(this).attr('aria-controls', 'programmes_' + id);

        // set up the panel attributes
        panel.attr('aria-hidden', !isVisible);
        panel.css('display', 'none');

        // add the toggle behaviour
        $(this).on('click', function (e) {
            // stops hrefs making the page jump when clicked
            e.preventDefault();

            // if it's showing, hide it
            if (isVisible) {
                panel.slideUp(400, function () {
                    panel.addClass('offscreen').slideDown(0);
                });
            } else {
                // otherwise...
                panel.slideUp(0, function () {
                    panel.removeClass('offscreen').slideDown(400);
                });
            }

            // switch the attribute value
            $(this).attr('aria-expanded', !isVisible);
            panel.attr('aria-hidden', isVisible);

            isVisible = !isVisible;

            // switch the Flaticon icon to the up state as the panel is open
            $(this).find('i').toggleClass('fa-chevron-up fa-chevron-down');
        });
    });

    window.onscroll = function () {
        if ($('#skip_a_to_z').length) {
            if ($('#skip_a_to_z').offset().top < window.scrollY) {
                $('#subject-to-top').css('display', 'block')
            } else {
                $('#subject-to-top').css('display', 'none')
            }
        }
    };

    $('#subject-to-top').click(function() {
        $('html, body').animate({
            scrollTop: '0px'
        });
    })
});
